import IconButton from '../icon-button/icon-button';
import { NOTIFICATIONS_TYPES } from '../../../helpers/constants';
import infoIcon from '../../../assets/icons/info.png';
import warningIcon from '../../../assets/icons/warning.png';
import successIcon from '../../../assets/icons/success.png';
import errorIcon from '../../../assets/icons/error.png';
import './notification.scss';

const getIconForType = type => {
    switch (type) {
        case NOTIFICATIONS_TYPES.success:
            return successIcon;
        case NOTIFICATIONS_TYPES.info:
            return infoIcon;
        case NOTIFICATIONS_TYPES.warning:
            return warningIcon;
        case NOTIFICATIONS_TYPES.error:
            return errorIcon;
        default:
            return null;
    }
}

const Notification = ({ type = 'success', name, message, showImage }) => {
    return (
        <div className={`glu-notification glu-notification-${type} glu-notification__border`}>
            {showImage ? <img src={getIconForType(type)} alt='info' /> : null}
            <div className='glu-notification__message'>
                {name ? <span className='glu-notification__item-name'>{name}</span> : null}
                {message}
            </div>
            <IconButton icon="close" />
        </div>
    );
};

export default Notification;
